// @flow

const iconsList = [
  'add',
  'alert',
  'arrow-down',
  'arrow-left',
  'arrow-right-2',
  'arrow-right',
  'arrow-tail-down',
  'arrow-tail-up',
  'arrow-up-down',
  'arrow-up',
  'article',
  'battery',
  'bell',
  'bolt',
  'book',
  'bookmark',
  'bug',
  'calendar',
  'camera',
  'check-alt',
  'check',
  'chevron-circle-down',
  'circle',
  'clear',
  'clipboard',
  'clock',
  'cloud',
  'code',
  'cog-gear',
  'copy',
  'credit-card',
  'custom-value',
  'delete',
  'disc',
  'download',
  'edit',
  'error',
  'external-link',
  'eye',
  'facebook',
  'filter',
  'flip',
  'folder',
  'heart',
  'help',
  'helpscout',
  'hide',
  'holding',
  'indeterminate-circle',
  'indeterminate',
  'info',
  'insert-field',
  'invite',
  'link',
  'linkedin',
  'list',
  'lock',
  'menu',
  'miscList',
  'more',
  'move',
  'path',
  'platform-build',
  'platform-clock',
  'platform-data',
  'platform-developer-docs',
  'platform-feedback',
  'platform-getting-started',
  'platform-grow',
  'platform-help',
  'platform-increase',
  'platform-launch',
  'platform-learn',
  'platform-mail',
  'platform-partner-tools',
  'platform-plus',
  'platform-share',
  'platform-smile',
  'platform-support',
  'platform-tag',
  'platform-team',
  'platform-trophy',
  'platform-validation',
  'platform-wb',
  'platform-zt',
  'play-circle',
  'plug',
  'plus',
  'power',
  'progress',
  'question',
  'reload',
  'restricted',
  'rss',
  'search',
  'social-facebook',
  'social-google-plus',
  'social-linkedin',
  'social-rss',
  'social-twitter',
  'social-youtube',
  'sort',
  'star-empty',
  'star-half',
  'star-with-checkmark',
  'star',
  'stopped',
  'stopwatch',
  'support',
  'target',
  'team',
  'test',
  'throttle',
  'trash',
  'user',
  'wand',
  'youtube',
  'zap-arrow',
  'zapier-logo',
];

type IconsMap = {
  [k: string]: string,
};

export const iconsMap: IconsMap = iconsList.reduce((accum, icon) => {
  accum[icon] = require(`./${icon}.svg`);
  // Work with CommonJS or ES6 module.
  if (accum[icon].default) {
    accum[icon] = accum[icon].default;
  }
  return accum;
}, {});
